import React from "react";
import CreditWalletPanel from "./CreditWalletPanel";

const CreditWalletPage = () => <CreditWalletPanel />;

export default CreditWalletPage;
